var map = {
	"./CONMAT-fake-report-ca.ts": [
		81392,
		1392
	],
	"./CONMAT-fake-report-en.ts": [
		85318,
		5318
	],
	"./CONMAT-fake-report-es.ts": [
		28385,
		8385
	],
	"./COSMOS-fake-report-ca.ts": [
		70915,
		915
	],
	"./COSMOS-fake-report-en.ts": [
		61457,
		1457
	],
	"./COSMOS-fake-report-es.ts": [
		36230,
		6230
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81981;
module.exports = webpackAsyncContext;